import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_431 implements Validator {

	public static id = 'CTRL_431';
	private message = 'error.ctr_431';


	public LOG: LogService = new LogService(CTRL_431);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		    const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_431.id + '_');


		    if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const delaisDateJusquauWithStepId = map.get(ctrl.value.rgCtrls.date);
    const dateCtrl = form.controls[delaisDateJusquauWithStepId];

				if (dateCtrl.value !== 'yyyy-MM-dd' && dateCtrl.value !=="" && new Date(dateCtrl.value).getTime() < new Date().getTime()) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}
}
